import { MfaService } from '@/services/mfa.service'

const state = {
    mfaToken: '',
    method: '',          // 'email' or 'totp'
    maskedEmail: '',
    expiresIn: 0,
    submitting: false,
    error: ''
}

const getters = {
    mfaPending: s => !!s.mfaToken,
    mfaMethod: s => s.method,
    maskedEmail: s => s.maskedEmail,
    submittingMfa: s => s.submitting,
    mfaError: s => s.error,
    mfaExpiresIn: s => s.expiresIn
}

const actions = {
    setChallenge({ commit }, { mfaToken, method, maskedEmail, expiresIn }) {
        commit('setChallenge', { mfaToken, method, maskedEmail, expiresIn })
    },

    clearChallenge({ commit }) { commit('clearChallenge') },

    async verify({ commit, state }, { code }) {
        commit('setSubmitting', true)
        commit('setError', '')
        try {
            const accessToken = await MfaService.verify(state.mfaToken, code, state.method)
            commit('auth/loginSuccess', accessToken, { root: true })
            commit('clearChallenge')
            return true
        } catch (e) {
            const data = e && e.response && e.response.data
            const msg = (data && data.error) || 'Verification failed.'
            const remaining = data && data.attempts_remaining
            commit('setError', remaining != null ? `${msg} ${remaining} attempt(s) remaining.` : msg)
            return false
        } finally {
            commit('setSubmitting', false)
        }
    },

    async resend({ state, commit }) {
        try {
            await MfaService.resend(state.mfaToken)
            commit('setError', 'A new code has been sent.')
        } catch (e) {
            const data = e && e.response && e.response.data
            commit('setError', (data && data.error) || 'Could not resend code.')
        }
    },

    async fallbackToEmail({ state, commit }) {
        try {
            const r = await MfaService.fallbackToEmail(state.mfaToken)
            commit('setChallenge', {
                mfaToken: r.mfa_token,
                method: r.mfa_method,        // 'email'
                maskedEmail: r.masked_email,
                expiresIn: r.expires_in
            })
            return true
        } catch (e) {
            const data = e && e.response && e.response.data
            commit('setError', (data && data.error) || 'Could not switch to email recovery.')
            return false
        }
    }
}

const mutations = {
    setChallenge(s, { mfaToken, method, maskedEmail, expiresIn }) {
        s.mfaToken = mfaToken
        s.method = method || 'email'
        s.maskedEmail = maskedEmail || ''
        s.expiresIn = expiresIn || 0
        s.error = ''
    },
    clearChallenge(s) {
        s.mfaToken = ''
        s.method = ''
        s.maskedEmail = ''
        s.expiresIn = 0
        s.error = ''
    },
    setSubmitting(s, v) { s.submitting = v },
    setError(s, v) { s.error = v }
}

export const mfa = {
    namespaced: true,
    state, getters, actions, mutations
}
